import { render, staticRenderFns } from "./forgetpassword.vue?vue&type=template&id=22dca8b8&lang=html&"
import script from "./forgetpassword.vue?vue&type=script&lang=js&"
export * from "./forgetpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports